/**
 * Errors both Sentry inits (apps/main and islands) drop. Keep per-app entries in the
 * respective `sentryInit`; anything caused by the network, a browser, or an extension
 * belongs here so it is filtered everywhere.
 */
export const SHARED_SENTRY_IGNORE_ERRORS: (string | RegExp)[] = [
  "Load failed", // Safari: network blip, not an app bug
  "Failed to fetch", // Chrome: network blip, not an app bug
  "NetworkError when attempting to fetch resource.", // Firefox: network blip, not an app bug
  "Can't find variable: WebAssembly", // @rive-app/canvas bug on browsers without WebAssembly
  "WebAssembly is not defined", // @rive-app/canvas bug on browsers without WebAssembly
  "unpkg.com/tesseract.js", // browser extension injecting an OCR worker; tesseract.js isn't in our codebase
  // Chrome for iOS and the Google app inject a closure-compiled script into every page; WebKit
  // attributes its frames to the page URL (always 194:41, 195:338, 475:363 whatever the page).
  // "La" is a minified name from that bundle, nothing in our code throws it. Anchored because a
  // bare "La" would substring-match "Load failed" — see BABYSITS-FRONTEND-12X and -14E.
  /^(Error: )?La$/,
  // Browser extension (translation/dictionary/dictation/OCR tool) whose injected script
  // rejects with the bare string "Request timeout <method>". Nothing in our codebase emits
  // that text, and the method name varies (isPredictionAvailable, *Distributor.getValue,
  // isMathOcrAvailable, isDictateAvailable, getDictionariesByLanguageId, ...), so match the
  // shape once instead of one entry per method — see BABYSITS-FRONTEND-YK through -ZB.
  /Non-Error promise rejection captured with value: Request timeout \S+$/,
  // Android WebView / in-app browser (Meta, reduced-UA "Android 10; K") whose injected
  // script calls its native @JavascriptInterface bridge while the WebView is being torn
  // down on unload. Chromium wraps the failure as this message; the method name varies
  // (batch, log, postMessage, ...). No first-party frames — see BABYSITS-FRONTEND-11E.
  /^Error invoking \S+: Java bridge method invocation error$/,
  // Old Chromium (Chrome Mobile <=106, Huawei Browser, Samsung Internet 19, Meta WebViews)
  // reports a ResizeObserver callback that changed layout as a window error event with this
  // wording. It is a browser safeguard, not an exception: nothing fails. On the search page
  // the observer is maplibre-gl's container observer, on the profile pages the description
  // textarea's. Modern engines use the depth-based algorithm and the wording "loop completed
  // with undelivered notifications", never reported for our pages, so that one stays visible
  // on purpose — see BABYSITS-FRONTEND-VZ and the per-city search issues such as -150.
  "ResizeObserver loop limit exceeded",
  // WebKit web-extension runtime (Safari and DuckDuckGo on iOS/macOS): an extension's content
  // script calls runtime.sendMessage from a tab WebKit can no longer resolve, and the rejection
  // lands in our global handler. That API exists only for extension content scripts; nothing in
  // our code calls it, and the events span every page type — see BABYSITS-FRONTEND-VA.
  "Invalid call to runtime.sendMessage(). Tab not found.",
];
